/**
 * Components
 */

import Button from '../../shared/components/button';
import Details from '../../shared/components/details';
import TabGroup from '../../shared/components/tab-group';
import Slider from './shared/slider';
import Form from './shared/form';
// import Jumplist from '../../shared/components/jumplist';
import List from '../../shared/components/list';
import MediaGallery from '../../shared/components/media-gallery';
// import MediaGallery from './shared/media-gallery';
import Player from '../../shared/components/player';
// import ProgressBar from '../../shared/components/progress-bar';
// import ProgressRing from '../../shared/components/progress-ring';
// import Reveal from '../../shared/components/reveal';
import RevealPassword from '../../shared/components/reveal-password';
import Tag from '../../shared/components/tag';
// import GMap from '../../shared/components/gmap';
import Table from './shared/table';

// ------
// Public
// ------

const index = () => {
	Button.init();
	Details.init();
	TabGroup.init();
	Slider.init();
	Form.init();
	// Jumplist.init();
	List.init();
	MediaGallery.init(null, {
		slider: {
			autoHeight         : false,
			grabCursor         : true,
			lazyPreloadPrevNext: 1,
			loop               : true,
			slidesPerView      : 'auto',
			spaceBetween       : 0
		}
	});
	Player.init({
		audio: {
			volume: 0.5
		},
		video: {
			volume: 0.5
		}
	});
	// ProgressBar.init();
	// ProgressRing.init();
	// Reveal.init();
	RevealPassword.init();
	Tag.init();
	Table.makeScrollable();

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	// GMap.init(null, {
	// 	apiKey  : window.pageInstance.settings.maps.google.id,
	// 	settings: {
	// 		// Siehe google-maps.js -> DEFAULTS
	// 		map: {
	// 			zoom: 14
	// 		}
	// 	}
	// });
	// }
};

// Export
export default index;
